import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { TbArrowLeft, TbCirclePlus } from 'react-icons/tb';
import BankStatutoryModal from '../../modals/hrm/employee/employeedetails/BankStatutoryModal';
import { Link } from 'react-router-dom';


const EmployeeDetailsHeader = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between px-3 py-3">
        {/* Left Side - Employee Details */}
<Link to="/employee-lists"  className='text-decoration-none text-dark ' >
        <div className="d-flex align-items-center">
          
          <TbArrowLeft size={22} className="me-2 text-dark" />
          <h6 className="fw-medium mb-0 text-dark">Employee Details</h6>
        </div>
</Link>

        {/* Right Side - Bank & Statutory Button */}
        <Button
          onClick={() => setShowModal(true)}
          className="d-flex align-items-center px-4 py-2"
          style={{
            backgroundColor: '#FF6B00',
            borderColor: '#FF6B00',
            fontWeight: '500',
            fontSize: '15px',
          }}
        >
          <TbCirclePlus size={20} className="me-2" />
          Bank & Statutory
        </Button>
      </div>

      {/* Separate Modal Component */}
      <BankStatutoryModal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  );
};

export default EmployeeDetailsHeader;